<template>
    <rkm-layout-body
        title="Lista de Paciente"
    >
        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/atencao-basica/ficha-complementar/List'

export default ({
    components: { List }
})
</script>